import { api } from 'src/pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';

export default class SupplierStatisticApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  /**
   * Get supplier statistics data
   * @returns Promise<any> - Supplier statistics data
   */
  public async getSupplierStatistics(): Promise<any> {
    return super.get(api.supplier_statistic);
  }
}
